// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3e-lJ","vLegacy":"SelectSecondary_vLegacy___ML0Y","error":"SelectSecondary_error__1DI4j","disabled":"SelectSecondary_disabled__6ROHu"};